var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg12PxSparkle2 = function Svg12PxSparkle2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    "aria-hidden": "true"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m6.5 10.25 1.345-3.404L11.25 5.5 7.845 4.154 6.5.75 5.154 4.154 1.75 5.5l3.404 1.346z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.492 10.508-.946.315-.316.947c-.102.306-.609.306-.711 0l-.316-.947-.946-.315a.375.375 0 0 1 0-.712l.946-.315.316-.947a.374.374 0 0 1 .71 0l.316.947.946.315a.375.375 0 0 1 0 .712Z"
  }))));
};
export default Svg12PxSparkle2;